import type { ArdoqId } from '@ardoq/api-types';
import type { Position } from '@ardoq/component-hierarchies';

/** Carries the view instance id a canvas registers under. */
export const CANVAS_HIT_TEST_ATTRIBUTE = 'data-canvas-hit-test';

export type ClientModelHitTest = (
  event: Pick<MouseEvent, 'clientX' | 'clientY'>
) => ArdoqId | null;

/** Where a node is now, in client coordinates. */
export type ClientNodeLocator = (nodeId: string) => Position | null;

export type CanvasHitTest = {
  /** Which component the view draws at a point. */
  hitTest: ClientModelHitTest;
  /**
   * Where the view draws a given node, asked by node id because a grouped view
   * draws one component as several nodes. Optional: a view that cannot answer
   * leaves anything anchored to one of its nodes where it last was, rather than
   * being wrong about it. Canvas views move their nodes without scrolling
   * anything, so this is the only way to follow one.
   */
  locate?: ClientNodeLocator;
};

const registry = new Map<string, CanvasHitTest>();
export const register = (viewInstanceId: string, hitTest: CanvasHitTest) =>
  registry.set(viewInstanceId, hitTest);
export const unregister = (viewInstanceId: string) =>
  registry.delete(viewInstanceId);
export const get = (viewInstanceId: string) => registry.get(viewInstanceId);
